import { datadogRum } from '@datadog/browser-rum';

const
  DD_APPLICATION_ID = process.env.REACT_APP_DD_APPLICATION_ID,
  DD_CLIENT_TOKEN = process.env.REACT_APP_DD_CLIENT_TOKEN,
  DD_SERVICE = process.env.REACT_APP_DD_SERVICE || process.env.npm_package_name,
  DD_VERSION = process.env.REACT_APP_DD_VERSION || process.env.npm_package_version,
  DD_ENV = process.env.REACT_APP_DD_ENV,
  DD_SAMPLE_RATE = process.env.REACT_APP_DD_SAMPLE_RATE,
  DD_SESSION_REPLAY_SAMPLE_RATE = process.env.REACT_APP_DD_SESSION_REPLAY_SAMPLE_RATE;

/** initialize datadog RUM */
export const initDatadog = () => {
  if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) return;
  datadogRum.init({
    applicationId: DD_APPLICATION_ID,
    clientToken: DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: DD_SERVICE || 'survey',
    env: DD_ENV || 'local',
    version: DD_VERSION,
    sampleRate: parseInt(DD_SAMPLE_RATE || '10', 10),
    sessionReplaySampleRate: parseInt(DD_SESSION_REPLAY_SAMPLE_RATE || '10', 10),
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  datadogRum.startSessionReplayRecording();
};
